import Echo from "laravel-echo";
import Pusher from "pusher-js";
window.Pusher = Pusher;

let EchoInstance = null;
try {
  // Configuração do Echo
  const echoConfig = {
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY || "hawkwebsockets",
    cluster: process.env.MIX_PUSHER_APP_CLUSTER || "mt1",
    wsHost: process.env.MIX_PUSHER_HOST || window.location.hostname,
    wsPort: process.env.MIX_PUSHER_PORT || 6001,
    wssPort: process.env.MIX_PUSHER_PORT || 6001,
    forceTLS: (process.env.MIX_PUSHER_SCHEME || "http") === "https",
    encrypted: process.env.MIX_PUSHER_ENCRYPTED === "true",
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    authEndpoint: "/broadcasting/auth",
    auth: {
      headers: {
        "X-CSRF-TOKEN": document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute("content"),
      },
    },
  };
  EchoInstance = new Echo(echoConfig);
  window.Echo = EchoInstance;
} catch (e) {
  // Fallback: não inicializa Echo, mas não lança erro
  window.Echo = null;
  // Opcional: log para debug, remova em produção
  if (process.env.NODE_ENV !== "production") {
    console.warn(
      "WebSocket/Echo não disponível, fallback para modo offline.",
      e
    );
  }
}

export default window.Echo;
